export const imageQualityWarning = (imageAreaPixels, imagePixels) => {
    const sm_printsize15x15pixels = 3312400; // 1820 * 1820;
    const sm_printsize20x30pixels = 8633994; // 2397 * 3602;
    const sm_printsize50x70pixels = 48816635; // 5905 * 8267;
    const sm_megapixels_0_4 = 360000; // 600*600 pixels
    const sm_megapixels_2 = 2000000;
    const sm_megapixels_5 = 5000000;
    const sm_megapixels_8 = 8000000;
    // Due to Express-bild selling pictures at 50x70, but only have 8mpix pictures,
    // we assume the quality is good enough, so reduce the original check from
    // 10MP to 8MP
    if (imageAreaPixels > sm_printsize50x70pixels) {
        console.log("Quality check: 50x70, 8MP", imageAreaPixels, imagePixels);
        return imagePixels < sm_megapixels_8;
    }
    else if (imageAreaPixels > sm_printsize20x30pixels) {
        console.log("Quality check: 20x30, 5MP", imageAreaPixels, imagePixels);
        return imagePixels < sm_megapixels_5;
    }
    else if (imageAreaPixels > sm_printsize15x15pixels) {
        console.log("Quality check: 15x15, 2MP", imageAreaPixels, imagePixels);
        return imagePixels < sm_megapixels_2;
    }
    console.log("Quality check: < 15x15, 0.4MP", imageAreaPixels, imagePixels);
    return imagePixels < sm_megapixels_0_4;
};
export const isGroupPicture = (image) => {
    return image.keywords.indexOf("group_picture") >= 0;
};
export const isMiniGroupPicture = (image) => {
    return image.keywords.indexOf("mini_group_picture") >= 0;
};
export const isIndividualPicture = (image) => {
    return image.keywords.indexOf("individual_picture") >= 0;
};
// Color picture tags
export const COLOR_PICTURE_TAGS = [
    "yellow",
    "red",
    "green",
    "blue",
    "grey",
    "violet",
];
// Group picture tags
export const GROUP_PICTURE_TAGS = [
    "group_picture",
    ...COLOR_PICTURE_TAGS,
    "subjectfav",
];
// Individual picture tags
export const INDIVIDUAL_PICTURE_TAGS = [
    "favorite",
    ...COLOR_PICTURE_TAGS,
    "subjectfav",
];
export function isColorPictureTag(tag) {
    const colorTags = COLOR_PICTURE_TAGS;
    return colorTags.includes(tag);
}
export const TAG_PATHS = {
    group_picture: "/tags/favorite.png",
    favorite: "/tags/favorite.png",
    yellow: "/tags/yellow.png",
    red: "/tags/red.png",
    green: "/tags/green.png",
    blue: "/tags/blue.png",
    grey: "/tags/grey.png",
    violet: "/tags/violet.png",
    subjectfav: "/tags/subjectfav.png",
    spare: "/tags/spare.png",
    hidden: "",
};
